module.exports = "/images/Reserve_A_Spot_Button_Hover.png?5d9ff6e99fc497d81f7d6a26c17ee7e1";